import React, { useState } from "react";
import { Container } from "react-bootstrap";
import Navbar from "../../../components/user/navbar/Navbar";
import Footer from "../../../components/user/footer/Footer";
import HeroSection from "../../../components/user/heroSection/HeroSection";
import HotDeals from "../../../subscreen/user/deals/hotDeals/HotDeals";
import InstantDeals from "../../../subscreen/user/deals/instantDeals/InstantDeals";
import TrendingDeals from "../../../subscreen/user/deals/trendingDeals/TrendingDeals";
import BannerCarousel from "../../../components/user/bannerCarousel/BannerCarousel";
import HowDealsWork from "../../../components/user/howDealsWork/HowDealsWork";
import WhyTime4Pulse from "../../../components/user/whytime4pulse/WhyTime4Pulse";
import FeaturedDeals from "../../../components/user/featuredDeals/FeaturedDeals";
import TopCategories from "../../../components/topCategories/TopCategories";
import ContactPage from "../../../components/user/contactPage/ContactPage";
import LatestBlog from "../latestBlog/LatestBlog";
import Testimonials from "../testimonials/Testimonials";
import TopShops from "../topShops/TopShops";
import SellerBanner from "../sellerBanner/SellerBanner";
import TopRatedDeals from "../topRatedDeals/TopRatedDeals";
import MarqueeBanner from "../../../components/user/Marqueebanner/Marqueebanner";
import MyNavbar from "../../../components/user/navbar/Navbar";
// import MyNavbar from "../../../components/user/navbar/Navbar";

const Home = () => {
  const [showExpiredPlaceholder, setShowExpiredPlaceholder] = useState(false);

  return (
    <Container fluid>
      <>
        <MarqueeBanner />
        {/* <MyNavbar /> */}
        <Navbar />

        <main style={{ paddingTop: "102px" }}>
          {" "}
          {/* 38px marquee + 64px navbar */}
          {/* baqi page content / routes */}
          <HeroSection
            onExpire={() => setShowExpiredPlaceholder(true)}
            onRestart={() => setShowExpiredPlaceholder(false)}
          />
          {/* <BannerCarousel /> */}
          <div id="instant-deals-section">
            {/* {showExpiredPlaceholder ? (
          <div className="expired-placeholder">
            <h2>Expired Instant Deals</h2>
          </div>
        ) : (
          <InstantDeals />
        )} */}
            <InstantDeals />
            <HotDeals />
            <TrendingDeals />
            <HowDealsWork />
          </div>
          {/* <FeaturedDeals /> */}
          {/* <TopCategories /> */}
          {/* <TopRatedDeals /> */}
          <WhyTime4Pulse />
          <TopShops />
          <SellerBanner />
          <Testimonials />
          <LatestBlog />
          <ContactPage />
          <Footer />
        </main>
      </>
    </Container>
  );
};

export default Home;
